import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // console.log("checkform controller connected");
    // console.log("查看报名信息", this.usernameValue, this.passwordValue);
  }
  static values = {
    username: String,
    password: String,
    idcard: String
  }
  postForm(event) {
    event.preventDefault();
    // console.log("查看报名信息");
    // alert("查看报名信息");
  }
  openFormWindow() {
    console.log("查看报名信息", this.usernameValue, this.passwordValue);
    const targetUrl = "https://xfhyjd.119.gov.cn/#/userLogin";
    const formData = {
      targetUrl,
      username: this.usernameValue,
      password: this.passwordValue,
      autoSubmit: true,
      captchaEnabled: true
    }
    if (window.electronAPI) {
      window.electronAPI.openFormWindow(formData)
    } else {
      alert("请在客户端打开");
    }
  }

  openScoreWindow() {
    console.log("查看分数信息", this.idcardValue, this.passwordValue);
    const targetUrl = "https://xfhyjd.119.gov.cn/#/cjcx";
    const formData = {
      targetUrl,
      idcard: this.idcardValue,
      password: this.passwordValue,
      autoSubmit: false,
      captchaEnabled: false
    }
    if (window.electronAPI) {
      window.electronAPI.openScoreWindow(formData)
    } else {
      alert("请在客户端打开");
    }
  }
}
